<section
  [class]="panelClasses"
  data-testid="collapsible-box">
  <button
    type="button"
    class="flex items-center justify-between w-full px-5 py-3.5 text-left cursor-pointer bg-transparent border-0"
    [ngClass]="classes.header"
    (click)="toggle()"
    [attr.aria-expanded]="expanded"
    [attr.aria-label]="title">
    <span
      [ngClass]="classes.title || 'label-medium font-bold text-on-surface opacity-50'">
      {{ title }}
    </span>
    <mat-icon
      class="!text-xl !w-5 !h-5 transition-transform duration-280 ease-in-out"
      [class.rotate-180]="expanded"
      [ngClass]="classes.chevron || 'text-on-surface opacity-50'"
      aria-hidden="true">
      expand_more
    </mat-icon>
  </button>

  <div
    class="grid transition-[grid-template-rows] duration-280 ease-in-out"
    [ngClass]="expanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'"
    [attr.aria-hidden]="!expanded">
    <div
      class="overflow-hidden min-h-0 transition-opacity duration-240 ease-in-out"
      [ngClass]="expanded ? 'opacity-100' : 'opacity-0'">
      <div [ngClass]="classes.body">
        <ng-content />
      </div>
    </div>
  </div>
</section>
